import { lazy, Suspense } from 'react'
import { iconSizes, Text } from '@common/ui'
import { IconAlertCircle } from '@common/ui/icons'
import MicrofrontendErrorBoundary from './MicrofrontendErrorBoundary'
import Center from '../../components/layout/Center'
import Link from '../../domain/entity/Link'

export type LearningUnitEditorWrapperProps = {
  entityId: string
  entityLinks: Array<Link>
  linkKeyFromString: (key: string) => unknown
  onRegisterPartialSubmit: (fn: () => Promise<Link[]>) => void
  mode?: 'edit' | 'view'
}

const LearningUnitEditor = lazy(
  // @ts-ignore
  async () => import('eidu-remotes/dpl/learning-unit-editor')
)

const ErrorFallback = () => (
  <Center style={{ minHeight: '200px', backgroundColor: 'var(--trellis-color-surface-variant)' }}>
    <IconAlertCircle size={iconSizes.xl} stroke={1.5} color="var(--trellis-color-negative)" />
    <Text>Learning Unit Editor Unavailable</Text>
  </Center>
)

const LearningUnitEditorWrapper = (props: LearningUnitEditorWrapperProps) => {
  return (
    <MicrofrontendErrorBoundary fallback={<ErrorFallback />}>
      <Suspense fallback={null}>
        <LearningUnitEditor {...props} />
      </Suspense>
    </MicrofrontendErrorBoundary>
  )
}

export default LearningUnitEditorWrapper
